import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StudentGuardiansDTO } from 'src/app/models/studentGuardianDto';
import { authData } from 'src/app/util/auth';
import { errorHandler } from 'src/app/util/errorHandler';
import { getImageUrl } from 'src/app/util/helpers';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-guardian-form-fields',
  templateUrl: './guardian-form-fields.component.html',
  styleUrls: ['./guardian-form-fields.component.scss']
})
export class GuardianFormFieldsComponent implements OnInit {
  @Input() public guardianToSave!: StudentGuardiansDTO;
  @Input() public states!: any[];
  @Input() public ChildLeavingWith!: any[];
  @Input() public companies!: any[];
  @Input() public createFamilyProfile: boolean = false;

  
  payload: any = {
  };

  loading = false;
  skeletonLoader = true;
  notification = {};

  constructor(private httpClient: HttpClient, private router: Router) { }

  ngOnInit(): void {
  }

  generatePreview(event: any): void {
    const file = event.target.files[0];

    if (event.target.files && file) {
      if (file.size > 2097152) {
        this.guardianToSave.ImageSize = 0;
        this.guardianToSave.ImageType = "jpeg";
        this.guardianToSave.PassportData = "";
        this.guardianToSave.ImageUrl = getImageUrl(undefined);
        this.payload = { ImageSize: 0, ImageType: "", PassportData: "" };
        this.notification = errorHandler({
          Message: "Image File size too large",
        });
      } else {
        const reader = new FileReader();
        reader.onload = (event: any) => {
          const name = file.name;
          const lastDot = name.lastIndexOf(".");

          this.payload = {
            ImageSize: file.size,
            ImageType: name.substring(lastDot + 1),
            PassportData: event.target.result.replace(
              /^data:image\/\w+;base64,/,
              ""
            )
          };
          
          this.guardianToSave.ImageSize = file.size;
          this.guardianToSave.ImageType = name.substring(lastDot + 1).toLowerCase();
          this.guardianToSave.PassportData = event.target.result.replace(/^data:image\/\w+;base64,/, "");
          this.guardianToSave.ImageUrl = getImageUrl(this.guardianToSave.PassportData);
        };

        reader.readAsDataURL(file);
      }
    }
  }
}
